import React from 'react';
import { cva } from 'class-variance-authority';
import ErrorMessage from '@/components/common/ErrorMessage';
import { cn } from '@/lib/utils';

const inputVariants = cva('flex w-full rounded-lg border px-4 py-2 border-[#D9DBE9] text-secondary outline-0 disabled:cursor-not-allowed disabled:opacity-50', {
    variants: {
        variant: {
            default: '',
            outline: '',
        },
        size: {
            default: 'h-12 px-4',
            sm: 'h-10 rounded-md px-4 text-sm',
            lg: 'h-11 rounded-md px-4 text-base',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});

const InputTextarea = React.forwardRef(({ className, groupClassName, size, variant, type, labelClassName, labelStyleClassName, labelText, errorType, errorData, customMessage, id, ...props }, ref) => {
    return (
        <div className={cn('form-input-item', groupClassName)}>
            {labelText && (
                <label htmlFor={id} className={cn(labelStyleClassName ? labelStyleClassName : 'text-sm capitalize mb-1 text-heading inline-block', labelClassName)}>
                    {labelText}
                </label>
            )}
            <textarea className={cn(inputVariants({ size, className, variant }), errorType ? 'invalid' : '')} ref={ref} {...props} />
            {errorType && <ErrorMessage errorType={errorType} errorData={errorData} customMessage={customMessage} />}
        </div>
    );
});

export { InputTextarea, inputVariants };
